const byteToHex = (byte: number) => `0${byte.toString(16)}`.slice(-2);

const generateId = () => {
  const arr = new Uint8Array(20);
  window.crypto.getRandomValues(arr);

  return Array.from(arr, byteToHex).join('');
};

const applicationIdentifier = (): string => {
  const key = 'atlasti-application-identifier';

  let identifier = localStorage.getItem(key);
  if (!identifier) {
    identifier = generateId();
    localStorage.setItem(key, identifier);
  }

  return identifier;
};

export { applicationIdentifier };
